// Best-effort prefill only; the field stays editable. No prefill for free-mail domains
// (a personal signup shouldn't seed "Gmail" as an org name) or unparseable emails.
const FREE_MAIL = new Set([
  'gmail', 'googlemail', 'outlook', 'hotmail', 'live', 'msn',
  'yahoo', 'ymail', 'icloud', 'me', 'proton', 'protonmail', 'gmx', 'aol',
]);
// Second-level labels that sit under a ccTLD (e.g. co.uk, edu.au, or.jp, gob.mx). Kept
// broad so the registrable label is picked, not the SLD — "no prefill beats wrong prefill".
const MULTI_PART_TLD = /\.(co|com|org|net|ac|edu|gov|govt|mil|sch|ltd|plc|or|ne|go|gob|gen)\.[a-z]{2}$/i;

export function organisationNameFromEmail(email: string | null | undefined): string | null {
  if (!email?.includes('@')) return null;
  const domain = email.split('@')[1]?.toLowerCase() ?? '';
  if (!domain.includes('.')) return null;
  const isMultiPart = MULTI_PART_TLD.test(domain);
  const labels = domain.replace(MULTI_PART_TLD, '').split('.').filter(Boolean);
  // With a multi-part TLD stripped, the registrable label is the last remaining one;
  // otherwise it's the second-to-last (dropping the single TLD).
  const registrable = isMultiPart ? labels.at(-1) : labels.at(-2);
  if (!registrable || FREE_MAIL.has(registrable)) return null;
  return registrable.charAt(0).toUpperCase() + registrable.slice(1);
}
